//Product.js
import React, { useContext } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Card, Button } from "react-bootstrap";
import { SvgBag, SvgEye } from "./Svgs";
import { API_BASE_URL } from "../Config";
import { formatCurrency } from "../utils";
import { CartContext } from "../contexts/CartContext";
import { useTranslation } from 'react-i18next';

import SaleIcon from '../assets/img/sale.webp';

function truncateProductName(productName, maxWords) {
  const words = productName.split(' ');
  if (words.length > maxWords) {
    return words.slice(0, maxWords).join(' ') + '...';
  }
  return productName;
}

function Product({ product, sourceScreen }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { addToCart, totalPlacedInCart } = useContext(CartContext);

  const newAvailableInitialQuantity = product.quantity_available - (totalPlacedInCart[product.id] || 0);

  const hasPrice = product.real_price !== null && product.real_price > 0;
  const hasDiscount = product.discount !== null && product.discount > 0;

  const discountedPrice = hasPrice && hasDiscount
    ? product.real_price - (product.real_price * product.discount / 100)
    : product.real_price;


  const handleAddToCart = () => {
    addToCart(product);
    // Verifica se o gtag está disponível antes de chamar
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'add_to_cart', {
        event_category: 'Carrinho de Compras',
        event_label: product.product_name,
        value: discountedPrice,
        original_price: product.real_price,
        discount_percentage: product.discount,
        event_location: location.pathname,
      });

      console.log(`✅ Evento enviado para o Google Analytics: ${product.product_name}`);
    } else {
      console.warn("⚠️ Google Analytics não está disponível no momento. Evento não enviado.");
    }
  };

  return (
    <Card className="h-100 text-center hover-card" style={{ position: "relative" }}>
      {/* Ícone de promoção, seguindo a lógica de ProductDetail.js */}
      {newAvailableInitialQuantity > 0 && hasPrice && hasDiscount && (
        <div className="sale-icon">
          <img src={SaleIcon} alt="Sale LM Brasil" />
        </div>
      )}

      <Card.Body>
        <Card.Title>
          <Button onClick={handleAddToCart} className="primary bt-bag">
            <SvgBag />
          </Button>
          {location.pathname !== `/product/${product.slug}` && (
            <>
              <br />
              <Button onClick={() => navigate(`/product/${product.slug}`)} className="primary bt-eye">
                <SvgEye />
              </Button>
            </>
          )}
        </Card.Title>

        <Link to={`/product/${product.slug}`}>
          <div className="image-container">
            <Card.Img
              variant="top"
              src={API_BASE_URL + (product.image || "/media/products/no-image.png")}
              className="img-fluid m-auto hover-image p-3"
              alt={product.product_name}
              style={{ width: "300px", height: "300px" }}
              decoding="async"
            />
          </div>
          <div className="info-container">
            <h4>{truncateProductName(product.product_name, 5)}</h4>
            <h5>{product.cod_catalog}</h5>

            {/* Indicação de produto esgotado */}
            {newAvailableInitialQuantity <= 0 ? <span className="sold-out">{t('sold_out')}</span> : null}

            <div className="card-text">
              {newAvailableInitialQuantity > 0 && hasPrice && hasDiscount && (
                <>
                  <h2 className="red-strike">
                    {formatCurrency(product.real_price)}
                  </h2>
                  <h2>
                    {formatCurrency(discountedPrice)}
                  </h2>
                </>
              )}

              {newAvailableInitialQuantity > 0 && hasPrice && !hasDiscount && (
                <h2 className="pb-3">
                  {formatCurrency(product.real_price)}
                </h2>
              )}
            </div>

          </div>
        </Link>
      </Card.Body>
    </Card>
  );
}

export default Product;